import Marionette from "backbone.marionette";

import DashboardTpl from "views/dashboard/dashboardView.ejs";

import CSS from "views/dashboard/dashboard.css";

import S from "session/session.js";
import T from "session/token.js";

export default Marionette.View.extend({
    template: DashboardTpl,
    render: function() {
        $('.content-wrapper').css({ 'margin-left': '230px' });
        this.$el.html(DashboardTpl);

    },
    onShow: function() {
        $("body").removeClass().addClass("hold-transition skin-black fixed layout-top-nav");
    },
});


//////////////////
// WEBPACK FOOTER
// ./app/views/dashboard/dashboardView.js
// module id = 181
// module chunks = 0